export const ONE_HUNDRED = 100;
export const ODF_PERCENT = 0.002;
export const ODF_PAYMENT = 'within 3 days!';
